//过滤指定省略
const moneyFormat = (str,num) => {
	if(str) {
    if(str.length > num) {
      return str.substring(0,num) + '...'
    }else{
      return str
    }
  }else{
    return str
  }
}
 
export default { moneyFormat };